import { ContentFactory } from '../../squidex';
import { BaseService } from '../base/base.service';

export class DynamicContentSchemaService extends BaseService {
    constructor(schemaName: string, contentFactory: ContentFactory) {
        super(schemaName, contentFactory);
    }
}
